import { Tokens } from '@/assets/tokens'
import { ChangeEvent } from 'react'
import styled from 'styled-components'
import { getRulesCount } from '../utils'
import { Advice } from '../../key-message/KeyMessage.styles'

interface GlobalContextRulesProps {
  globalRules: string
  onGlobalRulesChange: (value: string) => void
}

const GlobalRulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 8px;
  padding: 24px;
  background-color: ${Tokens.ColorBackground};
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 12px;
`

const GlobalRulesTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

const GlobalRulesSubtitle = styled.p`
  margin: 0 0 16px 0;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  line-height: 1.5;
`

const RulesTitleWithCounter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
`

const RulesCountSpan = styled.span`
  font-size: 12px;
  color: #666;
`

const RulesTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  max-height: 200px;
  padding: 12px;
  border: 1px solid #dee2ef;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  overflow-y: auto;

  &:focus {
    outline: none;
    border-color: #01c38d;
  }

  &::placeholder {
    color: #9ca3af;
  }
`

const RulesTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export function GlobalContextRules({ globalRules, onGlobalRulesChange }: GlobalContextRulesProps): JSX.Element {
  const rulesCount = getRulesCount(globalRules)

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onGlobalRulesChange(e.target.value)
  }

  return (
    <GlobalRulesContainer>
      <div>
        <GlobalRulesTitle>
          Regras de Contexto <Advice>(opcional)</Advice>
        </GlobalRulesTitle>
        <GlobalRulesSubtitle>
          Defina regras gerais que se aplicam a todas as análises, independente da fonte de dados ou polaridade. Utilize
          essas regras para fornecer contexto temporal para a IA.
        </GlobalRulesSubtitle>
      </div>

      <div>
        <RulesTitleWithCounter>
          <RulesTitle>Regras Globais</RulesTitle>
          <RulesCountSpan>{rulesCount} regras</RulesCountSpan>
        </RulesTitleWithCounter>
        <RulesTextArea
          placeholder="Digite as regras de contexto separadas por ponto e vírgula (;)&#10;Exemplo: Regra de contexto 1; Regra de contexto 2; Regra de contexto 3"
          value={globalRules}
          onChange={handleChange}
        />
      </div>
    </GlobalRulesContainer>
  )
}
